/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiAlertType } from './InternalApiAlertType';
import {
    InternalApiAlertTypeFromJSON,
    InternalApiAlertTypeFromJSONTyped,
    InternalApiAlertTypeToJSON,
    InternalApiAlertTypeToJSONTyped,
} from './InternalApiAlertType';

/**
 * Alert assignment
 * @export
 * @interface InternalApiAlertAssignmentCommand
 */
export interface InternalApiAlertAssignmentCommand {
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertAssignmentCommand
     */
    alertId: number;
    /**
     * 
     * @type {number}
     * @memberof InternalApiAlertAssignmentCommand
     */
    assigneeId?: number;
    /**
     * 
     * @type {InternalApiAlertType}
     * @memberof InternalApiAlertAssignmentCommand
     */
    alertType: InternalApiAlertType;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiAlertAssignmentCommand
     */
    offset?: Date;
}



/**
 * Check if a given object implements the InternalApiAlertAssignmentCommand interface.
 */
export function instanceOfInternalApiAlertAssignmentCommand(value: object): value is InternalApiAlertAssignmentCommand {
    if (!('alertId' in value) || value['alertId'] === undefined) return false;
    if (!('alertType' in value) || value['alertType'] === undefined) return false;
    return true;
}

export function InternalApiAlertAssignmentCommandFromJSON(json: any): InternalApiAlertAssignmentCommand {
    return InternalApiAlertAssignmentCommandFromJSONTyped(json, false);
}

export function InternalApiAlertAssignmentCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiAlertAssignmentCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'alertId': json['alertId'],
        'assigneeId': json['assigneeId'] == null ? undefined : json['assigneeId'],
        'alertType': InternalApiAlertTypeFromJSON(json['alertType']),
        'offset': json['offset'] == null ? undefined : (new Date(json['offset'])),
    };
}

export function InternalApiAlertAssignmentCommandToJSON(json: any): InternalApiAlertAssignmentCommand {
    return InternalApiAlertAssignmentCommandToJSONTyped(json, false);
}

export function InternalApiAlertAssignmentCommandToJSONTyped(value?: InternalApiAlertAssignmentCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alertId': value['alertId'],
        'assigneeId': value['assigneeId'],
        'alertType': InternalApiAlertTypeToJSON(value['alertType']),
        'offset': value['offset'] == null ? value['offset'] : value['offset'].toISOString(),
    };
}

